import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from 'hooks/usePermission';
import routes from '../routing/routes';

type Props = {
  /** Permission the current user must hold to view the wrapped route. */
  permission: string;
  children: ReactNode;
};

/**
 * Route guard that renders its children only when the current user holds the
 * required permission; otherwise it redirects to the app home. Used to gate the
 * "Externe Anbindungen" area so users without the permission are blocked in the
 * UI even if they navigate to the URL directly (#9731).
 */
const RequirePermission = ({ permission, children }: Props) => {
  const allowed = usePermission(permission);

  if (!allowed) {
    return <Navigate to={routes.signed.application} replace />;
  }

  return <>{children}</>;
};

export default RequirePermission;
